import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default (overrideClasses?: any) =>
  createStyles({
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 10,
      fontSize: '14px !important',
      minWidth: 400,
      backgroundColor: palette.deepBlue,

      '& .MuiIconButton-root': { padding: 0, width: 15, height: 15 },
      '& .MuiSvgIcon-root': { width: 15, height: 15 },
    },
    headerSuperAdmin: {
      backgroundColor: palette.navSuperAdmin,
    },
    headerAdmin: {
      backgroundColor: palette.grey800,
    },
    headerOperator: {
      backgroundColor: palette.grey800,
    },
    buttonDone: {
      color: palette.green,
    },
    titleResponse: {
      color: `${palette.darkGray} !important`,
      alignItems: 'flex-start',
      fontSize: '14px !important',
    },
    responseContentText: {
      fontWeight: 400,
      marginTop: 12,
    },
    headerResponse: {
      marginTop: 9,
      textAlign: 'center',
    },
    subTitleResponse: {
      marginTop: 14,
      fontWeight: 400,
      marginLeft: 0,
    },
    subTitleInformation: {
      marginTop: 20,
      fontWeight: 400,
    },
    erroModalContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px 20px 4px',
    },
    errorModal: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      fontSize: '14px !important',
      fontWeight: 500,
      color: palette.darkGray,
    },
    errorModalSuperAdmin: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      fontSize: '14px !important',
      fontWeight: 500,
      color: palette.lightNavSuperAdminActions,
    },
    content: {
      padding: 12,
      maxHeight: 470,
      overflowX: 'auto',
      fontSize: '12px !important',
    },
    contentNoBorder: {
      padding: '16px 8px 10px 8px',
      maxHeight: 470,
      overflowX: 'auto',
    },
    contentResponse: {
      padding: '5px 20px',
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '13px 20px',
    },
    responseIcon: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 23,
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: 10,
      padding: 15,
    },
    buttonClose: {
      color: palette.blue,
    },
    title: {
      fontSize: '14px !important',
      fontWeight: 500,
      paddingLeft: 5,
      color: palette.darkGray,
    },
    titleSuperAdmin: {
      fontSize: '14px !important',
      fontWeight: 500,
      paddingLeft: 5,
      color: palette.lightNavSuperAdminActions,
    },
    subtitle: {
      fontSize: '12px !important',
      fontWeight: 500,
      color: palette.offWhite,
    },
    subtitleSuperAdmin: {
      fontSize: '12px !important',
      fontWeight: 500,
      color: palette.lightNavSuperAdminActions,
    },
    footerItems: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      borderTop: `1px solid ${palette.borderGray}`,
    },
    dialogActions: {
      justifyContent: 'flex-end',
      display: 'flex',
    },
    closeButton: {
      padding: 0,
      color: palette.offWhite,
      '& .MuiSvgIcon-root': { width: 15, height: 15 },
    },
    closeButtonSuperAdmin: {
      padding: 0,
      color: palette.lightNavSuperAdminActions,
      '& .MuiSvgIcon-root': { width: 15, height: 15 },
    },
    contentText: { fontSize: '12px !important' },
    dialogScrollBody: {},
    ...overrideClasses,
  });
